// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"155":"1dfdb886","175":"6b6fb73e","610":"cdc8ddea"}[chunkId] + ".js";
};